import { render, staticRenderFns } from "./SnoozeAlertRSModal.vue?vue&type=template&id=dcd0ec38&scoped=true&"
import script from "./SnoozeAlertRSModal.vue?vue&type=script&lang=js&"
export * from "./SnoozeAlertRSModal.vue?vue&type=script&lang=js&"
import style0 from "./SnoozeAlertRSModal.vue?vue&type=style&index=0&id=dcd0ec38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd0ec38",
  null
  
)

export default component.exports